export default "__VITE_ASSET__CPZ0JHw2__"